import axios from "axios";
import Swal from "sweetalert2";
import { store } from "../redux/store";
import { setOnlineStatus } from "../redux/slices/networkSlice";
import { setLoading } from "../redux/slices/loaderSlice";

import { logout } from "../redux/slices/authSlice";
import { refreshToken } from "../redux/slices/authSlice";

import successIcon from "../assets/icons/successVerify.svg";
import errorIcon from "../assets/icons/errorIcon.svg";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use((config) => {
  if (!navigator.onLine) {
    store.dispatch(setOnlineStatus(false));
    Swal.fire({
      title: "You're offline", 
      text: "No internet connection",
      icon: null, 
      iconHtml:
          `<img src=${errorIcon} alt="error" style="width:50px;">`,  
    });
    return Promise.reject("You're offline. No internet connection");
  }
  store.dispatch(setOnlineStatus(true));
  store.dispatch(setLoading(true));
  return config;
});

api.interceptors.response.use(
  (response) => {
    store.dispatch(setLoading(false));
    const isRefreshEndpoint = response.config.url?.includes("/admin-refresh");
    if (
      !isRefreshEndpoint &&
      response.config.method !== "get" &&
      (response.data.success ||
        response.data.statusCode === 200 ||
        response.data.statusCode === 201)
    ) {
      Swal.fire({
        icon: null,
        iconHtml:
          `<img src=${successIcon} alt="error" style="width:50px;">`,
        title: "Success",
        text: response.data.message,
        timer: 2500,
      });
    }
    return response;
  },
  async (error) => {
    store.dispatch(setLoading(false));
  
    if (!error.response) {
      return Promise.reject(error);
    }
  
    const originalRequest = error.config;
    const RETRY_KEY = "__isRetryRequest";
  
    if (error.response.status === 401 && !originalRequest[RETRY_KEY]) {
      originalRequest[RETRY_KEY] = true;
  
      try {
        await store.dispatch(refreshToken()).unwrap();
  
        const nextAccessToken =
          store.getState()?.auth?.accessToken ||
          localStorage.getItem("token");
  
        if (!nextAccessToken) {
          throw new Error("No token after refresh");
        }
  
        originalRequest.headers = originalRequest.headers || {};
        originalRequest.headers["Authorization"] = `Bearer ${nextAccessToken}`;
  
        return api(originalRequest);
      } catch (err) {
        store.dispatch(logout());
        Swal.fire({
          title: "Session expired",
          text: "Your session expired. Please log in again.",
          icon: null,
          iconHtml: `<img src=${errorIcon} alt="error" style="width:50px;">`,
          timer: 5000,
        }).then(() => {
          window.location.href = "/login";
        });
  
        return Promise.reject(err);
      }
    }
  
    // All other errors
    if (error.response?.data?.message) {
      Swal.fire({
        icon: null,
        iconHtml: `<img src=${errorIcon} alt="error" style="width:50px;">`,
        title: "Ooops......",
        text: error.response.data.message,
      });
    }
  
    return Promise.reject(error);
  }
);

export default api;
